"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentParameterInferenceReportEntrySchemaTyped = exports.ComponentParameterInferenceReportEntrySchema = void 0;
exports.pickBestComponentParameterInferenceReportEntry = pickBestComponentParameterInferenceReportEntry;
const zod_1 = require("zod");
const VarianceTypes_1 = require("../VarianceTypes");
const InferenceReportEntryBase_1 = require("./InferenceReportEntryBase");
function pickBestComponentParameterInferenceReportEntry(a, b) {
    if (!a) {
        return b;
    }
    if (!b) {
        return a;
    }
    const aRank = getSourceRank(a.source);
    const bRank = getSourceRank(b.source);
    if (aRank > bRank) {
        return a;
    }
    if (bRank > aRank) {
        return b;
    }
    return a;
}
function getSourceRank(source) {
    switch (source) {
        case 'default':
            return 0;
        case 'specified':
        case 'module-value':
            return 1;
        case 'inferred':
            return 2;
        case 'parser':
            return 3;
        case 'partner':
            return 4;
        case 'hil':
            return 6;
        default:
            return 5;
    }
}
exports.ComponentParameterInferenceReportEntrySchema = InferenceReportEntryBase_1.InferenceReportEntryBaseSchema.extend({
    source: zod_1.z
        .literal('specified')
        .or(zod_1.z.literal('partner'))
        .or(zod_1.z.literal('inferred'))
        .or(zod_1.z.literal('default'))
        .or(zod_1.z.literal('hil'))
        .or(zod_1.z.literal('module-value'))
        .or(zod_1.z.literal('parser')),
    value: zod_1.z.union([zod_1.z.union([zod_1.z.string(), zod_1.z.number()]), VarianceTypes_1.ValueVarianceSchema]),
    disabled: zod_1.z.boolean().optional(),
    sourceField: zod_1.z.string().nullish(),
    varianceSourceField: zod_1.z.string().nullish(),
});
const ComponentParameterInferenceReportEntrySchemaTyped = (typeT) => InferenceReportEntryBase_1.InferenceReportEntryBaseSchema.extend({
    source: zod_1.z
        .literal('specified')
        .or(zod_1.z.literal('partner'))
        .or(zod_1.z.literal('inferred'))
        .or(zod_1.z.literal('default'))
        .or(zod_1.z.literal('hil'))
        .or(zod_1.z.literal('module-value'))
        .or(zod_1.z.literal('parser')),
    value: zod_1.z.union([typeT, VarianceTypes_1.ValueVarianceSchema]),
    disabled: zod_1.z.boolean().optional(),
    sourceField: zod_1.z.string().nullish(),
    varianceSourceField: zod_1.z.string().nullish(),
});
exports.ComponentParameterInferenceReportEntrySchemaTyped = ComponentParameterInferenceReportEntrySchemaTyped;
//# sourceMappingURL=ComponentParameterInferenceReportEntry.js.map